import { useUser } from '@hooks';

export const ADMIN_COMPANY_ID = 1;

export const useIsInternalUser = () => {
  const { companyId } = useUser();
  return companyId === ADMIN_COMPANY_ID;
};
